// Winners & Nominees year subnav — Swiper carousel of years.
// Always shows an odd number of slides (3 / 5 / 7 by breakpoint) so the
// active year can sit dead-center; clamps to the edges when the active year
// is too near the start/end of the list.
// Active and hover states are pure CSS — each slide owns its own lines/carets.

import Swiper from 'imports/swiper/swiper-bundle.esm.js'

const wnYearSubnav = {
    init() {
        document.querySelectorAll('[data-wn-subnav]').forEach((wrap) => {
            const el = wrap.querySelector('[data-wn-subnav-years]')
            if (!el) return

            const prev = wrap.querySelector('.wn-subnav__arrow--prev')
            const next = wrap.querySelector('.wn-subnav__arrow--next')

            const slides   = Array.from(el.querySelectorAll('.swiper-slide'))
            const activeIdx = slides.findIndex((s) => s.classList.contains('is-active-slide'))

            const swiper = new Swiper(el, {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 0,
                loop: false,
                grabCursor: true,
                watchOverflow: true,
                speed: 300,
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                    disabledClass: 'swiper-button-disabled',
                },
                breakpoints: {
                    // 5 across the in-between (tablet-ish) range so the big
                    // year numbers don't overlap; 7 only once it's truly wide.
                    600: { slidesPerView: 5 },
                    1300: { slidesPerView: 7 },
                },
            })

            const centerActive = (speed = 0) => {
                if (activeIdx < 0) return
                const sPV = Number(swiper.params.slidesPerView) || 1
                const halfShift = Math.floor((sPV - 1) / 2)
                // Swiper auto-clamps invalid indexes, which yields the
                // far-left / far-right behavior the design calls for at
                // the edges of the year list.
                swiper.slideTo(Math.max(0, activeIdx - halfShift), speed)
            }

            swiper.on('resize', () => centerActive(0))
            swiper.on('breakpoint', () => centerActive(0))

            centerActive(0)
        })

        // Mobile year strip — a plain overflow-x scroller. Touch devices
        // swipe it natively; this adds pointer drag-to-scroll so it also
        // works with a mouse / trackpad where there's no visible bar.
        document.querySelectorAll('[data-wn-subnav-strip]').forEach((strip) => {
            // Position the active year on load. The most recent year (first in
            // the list) loads flush left; every later year sits in the second
            // slot so the year before it stays visible. The strip clamps at the
            // right edge, so the oldest years advance until the last one lands
            // flush right instead of leaving a gap.
            const positionActive = () => {
                const active = strip.querySelector('.is-active-slide')
                if (!active) return
                const lead = active.previousElementSibling
                    ? active.previousElementSibling.offsetWidth
                    : 0
                const offset = active.getBoundingClientRect().left
                    - strip.getBoundingClientRect().left
                const max = strip.scrollWidth - strip.clientWidth
                strip.scrollLeft = Math.max(0, Math.min(strip.scrollLeft + offset - lead, max))
            }
            positionActive()

            let down = false
            let dragged = false
            let startX = 0
            let startScroll = 0

            strip.addEventListener('pointerdown', (e) => {
                // Reset for EVERY interaction (touch or mouse) so a stale
                // drag flag can't block a later tap.
                dragged = false
                // Touch swipes the strip natively; only mouse needs JS.
                if (e.pointerType === 'touch') return
                down = true
                startX = e.clientX
                startScroll = strip.scrollLeft
                strip.classList.add('is-dragging')
                // NOTE: no setPointerCapture — capturing the pointer
                // retargets the click event to the strip, which stops the
                // year <a> links from navigating. Move/up are tracked on
                // the document instead so a drag still works off-strip.
            })

            document.addEventListener('pointermove', (e) => {
                if (!down) return
                const dx = e.clientX - startX
                if (Math.abs(dx) > 4) dragged = true
                strip.scrollLeft = startScroll - dx
            })

            const end = () => {
                down = false
                strip.classList.remove('is-dragging')
            }
            document.addEventListener('pointerup', end)
            document.addEventListener('pointercancel', end)

            // Belt-and-suspenders — never start a native drag on the strip.
            strip.addEventListener('dragstart', (e) => e.preventDefault())

            // Don't follow a year link if the pointer was dragging.
            strip.addEventListener('click', (e) => {
                if (dragged) {
                    e.preventDefault()
                    e.stopPropagation()
                }
            }, true)
        })
    }
}

export default wnYearSubnav
